export const DataHelper = {
    getCookie: function (name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2)
            return parts.pop().split(';').shift();
    },

    getSsoSettings: function (cb) {
        fetch("/company/ssosettings")
            .then(res => res.json())
            .then(data => {
                cb(data);
            })
            .catch(error => console.log(error));
    },

    getCompany: function (cb) {
        fetch("/company/info")
            .then(res => res.json())
            .then(data => {
                cb(data.company);
            })
            .catch(error => console.log(error));
    },

    getCompanySettings: function (cb) {
        fetch("/company/settings", {
            method: "GET"
        })
            .then(response => response.json())
            .then(companySettings => {
                cb(companySettings);
            })
            .catch(error => console.log(error));
    },

    getOssApiConfig: function (cb) {
        fetch("/company/ossapiconfig", {
            method: "GET",
        })
            .then(response => response.json())
            .then(ossApiConfig => {
                cb(ossApiConfig);
            })
            .catch(error => console.log(error));
    },

    getCurrentUser: function (cb) {
        fetch("/account/currentuser", {
            method: "GET",
        })
            .then(response => response.json())
            .then(user => {
                cb(user);
            })
            .catch(error => console.log(error));
    },

    getOssApiToken: function () {
        const val = this.getCookie("OssApiToken");
        return val;
    },

    generateRandomString: function (length) {
        var result = "";
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }
};